import request from '../index';

export const getSubtitle = (contentType, contentId, streamId) =>
  request({
    url: `/contents/subtitles/${contentType}/${contentId}/${streamId}`,
  });
